export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '提问对象',
    dataIndex: 'full_name',
  },
  {
    title: '提问用户',
    dataIndex: 'user_realname',
  },
  {
    title: '提问内容',
    dataIndex: 'content',
  },
  {
    title: '状态',
    dataIndex: 'status',
    customRender: (text, record, index)=>{
      if(record.status===1){
        return '已通过';
      }
      if(record.status===0){
        return '待审核';
      }
    },
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
export const answerColumns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '回复用户',
    dataIndex: 'full_name',
  },
  {
    title: '回复内容',
    dataIndex: 'content',
  },
  {
    title: '状态',
    dataIndex: 'status',
    customRender: (text, record, index)=>{
      if(record.status===1){
        return '已通过';
      }
      if(record.status===0){
        return '待审核';
      }
    },
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];


